module.exports = __webpack_public_path__ + "static/multi-talks-477341ce7f170fa144dc393f7bf64552.mp4";